import { API_URL } from "./Config";
import { formatDate, formatDateForFiltering } from "./DateUtils";
import { IDetailsResponse } from "./IDetailsResponse";
import { PageResult, PageRequest } from "./Pagination";

export interface IComplianceInvestigation {
  complianceinvestigationid: string;
  issue: string;
  reference: string;
  status: string;
  title: string;
  dateraised: string;
  svid: string;
}

export interface IComplianceInvestigationList extends PageResult {
  list: IComplianceInvestigation[];
}

export interface IComplianceInvestigationDetails extends IDetailsResponse {
  complianceinvestigationid: string;
  reference: string;
  subject: string;
  status: string;
  licenceid: string;
  licenceprofileid: string;
  responselevel: string;
  title: string;
  origin: string;
  receptors: string;
  description: string;
  closedate: string;
  dateraised: string;
  licence_regno: string;
}

/*
    "complianceinvestigationid": "8e457ace-b626-e811-a2c7-0050568a2d1a",
    "reference": "CI001626",
    "subject": "Water Quality",
    "status": "Closed",
    "licenceid": "7e8aad0c-f8fd-434e-9cac-24a99738e069",
    "licenceprofileid": "2c551f0e-eb4b-457c-9d4e-54d689f192f4",
    "responselevel": "Low",
    "title": "P0690-03, Unauthorised emissions to sewer",
    "origin": "Instances of Non compliance",
    "receptors": "Water",
    "description": "A meeting was held with C&F Automotive on Thursday 8th March 2018 regarding recurring exceedances of ELV limits for sewer water and trigger levels for storm water. Actions agreed at the meeting are required to be carried out by the licensee.",
    "closedate": "2021-10-12T00:00:00",
    "dateraised": "2018-03-21T00:00:00"
*/

export const GetComplianceInvestigationsBySiteVisitFetchUrl = (
  siteVisitId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  var params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  let url = `${API_URL}/Ci/listbysvid?sv_id=${siteVisitId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/cis-by-sitevisitid`;
  }

  return url;
};

export function FormatComplianceList(rows: Array<any>) {
  return rows.map((item) => {
    return <IComplianceInvestigation>{
      complianceinvestigationid: item.complianceinvestigationid,
      dateraised: formatDate(item.dateraised),
      issue: item.issue,
      reference: item.reference,
      status: item.status,
      title: item.title,
      svid: item.svid,
    };
  });
}

export async function GetComplianceInvestigationDetailsAsync(
  complianceInvestigationId: string
): Promise<IComplianceInvestigationDetails> {
  var url = `${API_URL}/Ci/byid?ci_id=${complianceInvestigationId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/ci-details`;
  }

  var response = await fetch(url);
  var body = <IComplianceInvestigationDetails>await response.json();

  return <IComplianceInvestigationDetails>{
    response: response,
    complianceinvestigationid: body.complianceinvestigationid,
    reference: body.reference,
    subject: body.subject,
    status: body.status,
    licenceid: body.licenceid,
    licenceprofileid: body.licenceprofileid,
    responselevel: body.responselevel,
    title: body.title,
    origin: body.origin,
    receptors: body.receptors,
    description: body.description,
    closedate: formatDate(body.closedate),
    dateraised: formatDate(body.dateraised),
    licence_regno: body.licence_regno,
  };
}
